var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewHairstyle1E(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "type3_x5F_new_hair:"
  }, /*#__PURE__*/React.createElement("g", {
    id: "new_x5F_1a"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M494.5,187.7c-9.6-33.9-22-61-46-88.2c-8.8-9.9-30-24.2-43.9-25.2c-19.4-1.5-31.4,2.3-47.8,10.3 c-16.4-8-26.8-11.3-47-8.8c-16.3,2-35.9,13.8-44.7,23.8c-24,27.2-36.4,54.3-46,88.2c-18.1,63.7-18.4,136.4-16.7,201.8 c2.1,78.3,1,154,8.7,232.4c9.1-1.8,21.5-2.4,30.3-0.9l0,0l0,0l2.6,1.4l0.8-48.2l8.5,44.8l6.9-24.4l2,30.1 c16-3.4,40.5-5.3,57.1,0.6l-4.2-233.3c-28.8-22.6-51.6-52.6-60.6-86.3c-0.5-2.8-1-5.7-1.2-8.6c-8.8,2.8-15.8-1.5-18.1-11.3 c-2.5-10.5-6.1-14.9-8.3-25.8c-3.1-15.7,8.8-26.8,18.7-23.9c9.8,2.7,6.8,22.4,8.6,46.4c3.4-16.1,5.4-30.7,8.5-46.4 c7.5-3.5,14.3-8.3,19.5-15.9c3.5-4.2,6.7-8.7,9.6-13.3s5.3-9.2,7.4-13.7c0.4-0.8,0.9-1.6,1.3-2.5c2-0.6,4-1.1,5.9-1.6 c6.6-1.7,13.3-3.2,20-4.3l0,0c0.3,0,0.6-0.1,0.9-0.1c1.3-0.2,2.7-0.4,4-0.6l0,0c2-8.6,5.8-20.5,9.5-24.9 c-2.2,6.1-3.9,17.3-3.4,24.3c0.7-0.1,1.4-0.1,2.1-0.2l0,0c4.8-0.4,9.7-0.5,14.7-0.4s10.7,0.4,16.6,0.8c0.9-4.1,1.4-8.9,1.6-13 c1.7,4.1,3.5,9.9,3.9,13.4c0.1,0,0.2,0,0.3,0c0.7,0.1,1.5,0.1,2.2,0.2c2.8,0.3,5.5,0.6,8.3,1c-0.9-13.5-6.3-26.5-10.3-34.9 c0.1,0.1,0.1,0.1,0.2,0.2c2.1,2.1,4.5,5.9,6.1,8.4c0.7,1.1,6,7.7,12.3,27.7c1,0.2,1.9,0.4,2.9,0.6c1.3,0.3,2.6,0.5,3.8,0.8 c4,1,7.7,2.1,11.1,3.4c0.3,0.6,0.6,1.1,0.9,1.7c2.1,4.5,4.6,9.1,7.4,13.7c2.8,4.6,6,9.1,9.6,13.3c5.2,7.6,14,15.2,21.6,18.7 c5.4,15.3,9.2,26.2,11.3,43.4c2.8-32.5,5.3-47.3,12.2-47.2c9,0.2,13.9,14.9,13.5,21.8c-0.7,11.1-2.2,19-5.2,28.5 c-3.1,9.7-9.8,16.8-19.6,16.1c-7.7,29.5-24.6,55.9-46.3,76.2c-1.7,1.7-3.4,3.3-5.1,4.9c-5.1,4.8-10.3,9.2-15.6,13.1l-3.8,227 c9.4-2.5,24.9-3.6,35-1.5c-0.5-0.1-0.9-0.2-1.4-0.3v0.2l3.8,1.3l-1.1-54.1l9.6,50.7l6.9-24.4l-6.8,24.3l0.2,1.7l7.1-19.9l1.6,24 c14.9-3.1,37-5,53.3-0.6c2.2-79.1,4.9-153.7,7.1-232.8C511.2,326.1,512.6,251.4,494.5,187.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85898B",
    d: "M253.5,620.3l7-20.6l-0.3-5l-6.8,24.2C253.5,619.7,253.5,620.3,253.5,620.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M385.6,146.9c0.4,0.4,0.7,0.8,1.1,1.1C386.3,147.7,386,147.3,385.6,146.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M387.3,148.7c0.3,0.4,0.6,0.7,1,1.1C387.9,149.4,387.6,149.1,387.3,148.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M387.1,150.7c0.4,0.4,0.7,0.7,1.1,1.1C387.9,151.5,387.5,151.1,387.1,150.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M383.5,144.7c0.5,0.5,1.1,1.1,1.6,1.6C384.6,145.8,384,145.3,383.5,144.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M393.3,156.4c0.4,0.6,0.8,1.2,1.2,1.8C394.1,157.5,393.7,156.9,393.3,156.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M391.8,154.4c0.3,0.5,0.7,0.9,1,1.4C392.5,155.3,392.2,154.8,391.8,154.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M360.3,130.6c-1.1-0.5-2.2-1.1-3.3-1.6C358.1,129.5,359.2,130.1,360.3,130.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M305.2,182.3c1.2-2.3,2.5-4.7,3.7-7C307.7,177.6,306.4,180,305.2,182.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M373.7,138.9c-0.6-0.5-1.3-0.9-1.9-1.4C372.4,138,373.1,138.4,373.7,138.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M385.7,149.3c-0.4-0.4-0.9-0.8-1.3-1.3C384.9,148.5,385.3,148.9,385.7,149.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M380.4,144.3c-0.9-0.8-1.7-1.5-2.6-2.2C378.7,142.8,379.5,143.5,380.4,144.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M383.1,146.8c-0.5-0.5-1-0.9-1.5-1.3C382.1,145.8,382.6,146.3,383.1,146.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M396.1,160.6c-0.5-0.7-1-1.5-1.5-2.2C395.2,159.1,395.7,159.9,396.1,160.6L396.1,160.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M363.6,132.4c-0.8-0.4-1.5-0.8-2.3-1.2C362.1,131.5,362.9,131.9,363.6,132.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M391.9,155.8c-0.3-0.3-0.6-0.7-0.9-1C391.3,155.1,391.6,155.5,391.9,155.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M370.8,136.8c-1-0.7-2-1.3-3-2C368.8,135.5,369.8,136.1,370.8,136.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M376.8,141.3c-0.6-0.5-1.2-1-1.9-1.5C375.5,140.3,376.1,140.8,376.8,141.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M367.2,134.5c-0.8-0.5-1.7-1-2.6-1.5C365.5,133.4,366.4,134,367.2,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M390.3,152.4c0.3,0.4,0.6,0.8,0.9,1.2C391,153.2,390.7,152.8,390.3,152.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M394.4,158.6c-0.3-0.3-0.5-0.6-0.8-0.9C393.9,158,394.1,158.3,394.4,158.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M388.8,150.6c0.3,0.4,0.6,0.8,0.9,1.1C389.5,151.3,389.1,150.9,388.8,150.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M253.5,620.3l7-20.6l-0.3-5l-6.8,24.2C253.5,619.7,253.5,620.3,253.5,620.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#785940",
    points: "447.1,594.7 440.3,619 440.4,620.7 447.5,600.8 447.5,600.8  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M428.7,557.9l0.7,63.4c-0.5-0.1-0.9-0.2-1.4-0.3v0.2l3.8,1.3l-1.1-54.1l0,0L428.7,557.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M241.8,557.9l0.7,63.4c-0.3-0.1-0.7-0.1-1-0.2l0,0l2.6,1.4l0.8-48.2l0,0L241.8,557.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M420.9,150.8c-10.3-26-37.1-40.1-60-37c0.5-2.4,0.8-4.9,1-7.5c7.9-6.7,29.4-8.2,39.9-1.1 c-9.7-10.3-32.2-7.6-39.7-2c0.1-2.4,0-4.7-0.3-6.9c12.4-13.8,39.6-17.5,55.5-7.6c-14.8-12.9-42.1-8.3-55.9,5 c-0.5-2.7-1.4-5.1-2.7-7c0.3,2.5,0.5,5,0.5,7.6c-7.2-5.2-17.4-8.5-28.4-7.3c10.4,1,20.8,3.4,28.5,10.2c0,2.2-0.1,4.3-0.2,6.5 c-12.9-9.8-38.9-9.9-49.7,3.2c11.8-10,36.9-11.9,49.4,0.4c-0.2,2.2-0.3,4.4-0.5,6.4c-21.8-10.3-47.4,5.8-57.5,23.9 c14.8-16,36.2-31.4,57.1-20.5l0.1-0.4c-0.3,2.9-0.5,5.7-0.7,8.2c1.1-1.8,2.2-4.8,3.1-8.4C382.3,114.3,410,131.2,420.9,150.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M273.9,197.9c-14.4,21.2-31.6,40-58.7,41.7c26.6-0.6,47.6-16.9,62.7-38.9c17.7-25.5,22.5-54.1,49.8-70 h-0.1C300.5,145.7,290.8,173.2,273.9,197.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M253.6,212c12.1-14.2,16.2-29.3,25.4-44.4l0,0c-9.6,14.8-17.9,27.7-29.1,41.1 c-9.7,11.3-19.9,20.8-35,24.4C229.7,230.5,242.9,224.1,253.6,212z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M487.5,234.4c-7.6-9.1-17-15.6-26.3-23.8c-16-13.7-30.3-26.7-35.8-47.5c4.6,20.7,16.3,36.9,32.6,51.2 c9.3,8.4,19.6,14.3,27.5,22c8,7.5,15.3,17.4,15,29.9C501.1,253.8,494.9,243,487.5,234.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M500.5,266.2v-0.1C500.5,266.2,500.5,266.2,500.5,266.2L500.5,266.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M480.3,177.9c7.5,20,17.2,36.4,18.6,57.7c-0.7-21.3-6.7-39.3-14.1-59.6c-9.4-23.3-21.4-41.8-39.6-58l0,0 C463.4,134.9,470.8,155.1,480.3,177.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M259.8,155.2L259.8,155.2c-9.6,11.5-18.5,21.1-26.3,34.6c-6.6,11.7-10.3,22.6-14.8,34.8 c5-12,11.3-21.5,18-32.9C244.6,178.5,250.5,167,259.8,155.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M471,206.9c9.3,11.1,19.6,18.6,24.7,32.1c-4.2-13.6-11.9-24.2-20.9-35.3c-10.4-12.4-18-24.6-21.3-40.7 l0,0C456.2,178.8,459.7,193.7,471,206.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M215.7,434.1c-1.8-50.8-3.8-94,0.1-143.6c-4.5,49.5-5.5,92.9-3.9,143.7c2.4,58.7,3.5,108,10,165.1v-0.1 C215.9,542.1,218.3,492.8,215.7,434.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M298.2,595.5L298.2,595.5c3.9-36.1,5.6-67.5,2.6-104.6c-2.7-32.1-8.2-59-12.3-90.2 c3.4,31.3,5,58.6,7.5,90.5C298.6,528.1,301.6,559.3,298.2,595.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M259.3,505.8c-0.1-1.6-0.3-3.2-0.5-4.8c0,0.3,0,0.6,0,0.9c-0.5,32.5,1.4,59.9-2.8,91.6v-0.1 c4.7-31.5,7.4-58.8,7.7-91.5c-0.1-28.3-2.9-52.2-4.5-79.8c0.7,21.7,0.1,41.2-0.2,62.3C260.3,492.1,260.7,499.8,259.3,505.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M244.2,533.7L244.2,533.7c0-14.3,0.1-27.4,0.1-40.7c-0.2,1.4-0.4,2.8-0.5,4.2l-1.6-12.2 c0.4-2.5,1.2-5.1,2.1-7.8c-0.1-5.9-0.2-11.8-0.4-18c-0.6-22.8-2.3-42.3,0.8-64.6c-3.7,22.1-6.1,41.7-5.7,64.7 C239.5,485.8,243.7,507.8,244.2,533.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M490,312.8c2.6,13.6,4.3,26.8,5.4,39.9c0-1.1,0-2.2-0.1-3.2c1,3.5,1.2,7,0.6,10.4 c2.3,34.3,0.7,67.6,0,104.9c-1.5,46.8-2,86.8-6,132.5c4.7-45.7,9.1-85.4,10.9-132.4c1.3-54.2-0.5-100.2-10.9-152.2L490,312.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M483,348c0.2,1,0.4,2,0.7,3c-1.7-10.6-4.2-20.6-6.9-31.5c3.5,17,3.5,32.1,4.5,49.5 c1.1,20.2,3,37.3,2.5,57.3l0,0c0.9-19.9,3.3-37,2-57.5c-0.2-2.6-0.4-5.1-0.7-7.6c-0.7-1.7-1.3-3.5-1.7-5.1L483,348z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M447.1,478.5c-1.2,38.1-1.9,70.2-5.3,107.4v-0.1c3.9-37.1,9.3-68.8,10.2-107.2 c0.7-33.2-2.2-61.4-6.4-93.5C449.2,417.4,448,445.6,447.1,478.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M474.7,554.6c-2.4,20.8-3.7,38.6-8.9,58.7l0,0c5.6-19.8,11.6-36.9,13.8-58.1c1.8-18.4,0.2-34.2-1.4-52 C479.1,521.1,476.7,536.6,474.7,554.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M423.1,459.4c-0.9-26.3-2.6-48.8-0.2-74.6c-3.1,25.7-5.4,48.2-4.7,74.8c0.9,30.7,5.4,56,8,85.8v-0.1 C424,515.5,424.2,489.8,423.1,459.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.8,83.6L314.8,83.6c-18.1,3.6-33.2,11.4-46.3,25.5c-11.2,12.4-17.4,25.2-23.6,40c6.6-14.6,14.8-26.1,25.7-38 C283.3,97.7,296.5,87.6,314.8,83.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.4,203.9L245.4,203.9c13.4-15.4,22.3-30.9,33.2-48.5c9.5-15,17.3-29.3,33.5-37.2c-16.2,7.4-26.3,20.6-36,35.7 C264.9,171.6,258.7,188.2,245.4,203.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.6,210.3c-5.9-18.3-11.3-34.2-22.2-51c-9.6-14.2-19.9-25.2-33.5-34.9c13.3,10.3,20.9,23,30.2,37 C471.6,177.9,480.3,192.1,486.6,210.3L486.6,210.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.6,91.1c-10.2-2.9-19.4-2.7-29.4-1c10.1-1.4,19,0,28.8,2.8c11.1,3.5,20.5,8.3,27.7,17.8 C428.9,101.3,420.3,94.7,408.6,91.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.7,110.8L435.7,110.8L435.7,110.8L435.7,110.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.7,541.1L234.7,541.1c-3.2-35.1-4.7-65.2-5.3-101c-0.3-30.9,0.1-57.6,6.9-87.4c-7.4,29.5-11,56.1-10.8,87.4 C225.9,476.3,231.2,506.1,234.7,541.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,605.8c4-24.1,6.6-45.2,6-70.3c-0.6-21.8-3.6-40-5.5-61.2c1.3,21.2,1.1,39.7,1.5,61.3 C280.4,560.5,281.6,581.5,278,605.8L278,605.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.4,505.8c-0.1-27.4-1.3-50.8-1.9-77.6c0.1,26.9-1.9,50.2-2,77.6c0,31.8,2.4,58.4,6,89.2v-0.1 C406.2,564,407.5,537.5,407.4,505.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.3,341.7c4.4,30.1,4.7,56.5,4.5,87.4c-0.4,35.7-1.3,65.8-6.4,100.5v-0.1c5.5-34.6,10.2-64.4,10.3-100.4 C469.7,398,466.3,371.6,461.3,341.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.9,118.9L407.9,118.9L407.9,118.9L407.9,118.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.3,105.3c-7.3-1.5-14.3-1.3-20.6,2.3c6.6-3.4,13.3-1.9,20.2-0.4c7.9,2.1,15.1,4.8,20.1,11.6 C403.2,112,396.7,107.5,388.3,105.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.2,94L343.2,94c-13.3-2.6-25.9-1.6-38.4,5.4c-10.6,6.3-17.1,15-22.6,25.3c5.8-10.3,13.4-17.7,23.6-23.6 C317.7,94.5,329.7,91.6,343.2,94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M347.5,134.8c2.8-1.9,5.2-3.7,9.6-5.8c1.1,0.5,2.2,1,3.3,1.6c0.3,0.2,0.7,0.3,1,0.5 c0.8,0.4,1.5,0.8,2.3,1.2c0.3,0.2,0.7,0.4,1,0.6c0.9,0.5,1.7,1,2.6,1.5c0.2,0.1,0.4,0.2,0.6,0.3c1,0.6,2,1.3,3,2 c0.3,0.2,0.7,0.5,1,0.7c0.6,0.5,1.3,0.9,1.9,1.4c0.4,0.3,0.8,0.6,1.2,0.9c0.6,0.5,1.3,1,1.9,1.5c0.3,0.3,0.7,0.5,1,0.8 c0.9,0.7,1.7,1.5,2.6,2.2c0.4,0.4,0.8,0.7,1.2,1.1c0.5,0.4,1,0.9,1.5,1.3c0.5,0.4,0.9,0.9,1.4,1.3c0.4,0.4,0.9,0.8,1.3,1.3 c0.5,0.5,0.9,0.9,1.4,1.4c0.4,0.4,0.7,0.7,1.1,1.1c0.9,1,1.9,2,2.8,3c0.3,0.3,0.6,0.7,0.9,1c0.6,0.6,1.1,1.2,1.7,1.9 c0.3,0.3,0.5,0.6,0.8,0.9c0.6,0.7,1.2,1.3,1.7,2l0,0c-0.5-0.7-1-1.5-1.4-2.2c-0.1-0.1-0.1-0.2-0.2-0.3c-0.4-0.6-0.8-1.2-1.2-1.8 c-0.1-0.2-0.3-0.4-0.4-0.6c-0.3-0.5-0.7-0.9-1-1.4c-0.2-0.2-0.4-0.5-0.5-0.7c-0.3-0.4-0.6-0.8-0.9-1.2c-0.2-0.2-0.4-0.5-0.6-0.7 c-0.3-0.4-0.6-0.8-0.9-1.1c-0.2-0.2-0.4-0.5-0.6-0.7c-0.3-0.4-0.6-0.7-1-1.1c-0.2-0.2-0.4-0.5-0.6-0.7c-0.4-0.4-0.7-0.8-1.1-1.1 c-0.2-0.2-0.4-0.4-0.5-0.6c-0.5-0.6-1.1-1.1-1.6-1.6c-4.4-4.4-9.1-8.4-14.3-11.9c-3.9-2.6-8-5-12.3-7c-4.4,2-8.5,4.4-12.3,7 c-5.2,3.5-9.9,7.5-14.3,11.9c-8.2,7.8-14.9,18.8-21.3,30.6c-1.3,2.3-2.5,4.6-3.7,7c-1.5,2.9-3,5.7-4.6,8.6l0,0 c2-0.6,4-1.1,5.9-1.6C314.9,169,328.6,147.5,347.5,134.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M351.9,140c-12.6,10.8-21.9,29-25.3,45l0,0c0.3,0,0.6-0.1,0.9-0.1c1.5-0.2,2.8-0.4,4.1-0.6 c2-8.6,5.8-20.5,9.5-24.9c-2.2,6.1-3.9,17.3-3.4,24.3c0.7-0.1,1.4-0.1,2.1-0.2l0,0C339.4,162.4,345.6,152.4,351.9,140z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M372.7,165.8c0,1.5-0.1,3.2-0.2,5.1c1.7,4.1,3.5,9.9,3.9,13.4c0.1,0,0.2,0,0.3,0c0.7,0.1,1.5,0.1,2.2,0.2 l0,0C378,178.5,375.9,171.8,372.7,165.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M377.3,150.8c2.1,2.1,4.5,5.9,6.1,8.4c0.7,1.1,6,7.7,12.3,27.7c1,0.2,1.9,0.4,2.9,0.6 c1.3,0.3,2.6,0.5,3.8,0.8l0,0C397.6,174.2,390.1,160.1,377.3,150.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.1,189.3c-5.9-13-10.6-24.6-12.8-38.8c1.6,14.1,3.3,26.8,9.3,40.4c7.2,15.7,17.5,26.4,30.3,36.6l0,0 C437.1,216.9,430.1,204.2,423.1,189.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M243.8,497.1c0.1-1.4,0.3-2.8,0.5-4.2c1.3-8.6,3.6-17.2,6.7-24.4c2.7,9.7,6.2,21.7,7.8,32.4 c0.2,1.6,0.4,3.2,0.5,4.8c1.3-6,1-13.6-0.4-21.4c-1.6-9.1-4.7-18.3-8.3-25.3c-1.6,5.5-4.4,11.9-6.4,18.1 c-0.9,2.7-1.6,5.3-2.1,7.8L243.8,497.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M495.4,349.5c0.1,1,0.1,2.1,0.1,3.2c-0.2,5.4-1.9,11.7-4.3,15.7c-1.6-2.7-5.3-9-7.4-17.3 c-0.3-1-0.5-2-0.7-3l0.4,8.1c0.3,1.6,0.9,3.3,1.7,5.1c1.7,4,4.1,8,6.2,10.7c2.3-3.5,4-7.7,4.7-12 C496.5,356.5,496.4,353,495.4,349.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewHairstyle1E);
export default __webpack_public_path__ + "static/media/new_hairstyle_1e.f9f9f9ec11ade2ce10ec7102e90dadbd.svg";
export { ForwardRef as ReactComponent };